module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-258.5b26a97.woff2";